import React from "react"
import Layout from "../components/layout"
import Helmet from "react-helmet"
import { Link } from "gatsby"

import style from "../components/index.module.scss"

import LogoOverlay from "../assets/logo-overlay.inline.svg"
import FullCycleDevelopment from "../assets/full-cycle-development.inline.svg"
import Scale from "../assets/scale.inline.svg"
import Bpm from "../assets/bpm.inline.svg"
import SchemaComponent from "../components/schema-component"

export default () => (
  <Layout>
    <Helmet>
      <title>Obicis - Software Development</title>
      <meta
        name="description"
        content="Obicis Ltd. develops software for web, mobile, and enterprise. 
        We do IT consulting and business process management (BPM) automation solutions."
      />
      <meta property="og:title" content="Obicis - Software Development" />
      <meta property="og:url" content="https://www.obicis.com/" />
      <meta
        property="og:description"
        content="Obicis Ltd. develops software for web, mobile, and enterprise. 
        We do IT consulting and business process management (BPM) automation solutions."
      />
    </Helmet>
    <SchemaComponent
      description="Obicis is home to experienced experts providing ICT consulting and software development services."
      breadcrumb={{
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.obicis.com/",
          },
        ],
      }}
    />
    <div className={["hero", style.hero].join(" ")}>
      <div className={["content", style.heroContent].join(" ")}>
        Software development
        <br />
        from&nbsp;<b>idea</b> to&nbsp;<b>delivery</b>
      </div>
    </div>
    <div className={["logo-overlay", style.logoOverlay].join(" ")}>
      <div
        className={["logo-overlay-side", style.side, style.left].join(" ")}
      ></div>
      <div className={["logo-overlay-center", style.center].join(" ")}>
        <LogoOverlay
          className={["logo-overlay"].join(" ")}
          aria-label={"Obicis logo"}
        />
      </div>
      <div
        className={["logo-overlay-side", style.side, style.right].join(" ")}
      ></div>
    </div>
    <div className={["content"].join(" ")}>
      <h1>What we do</h1>
      <div className={["content-container", style.container].join(" ")}>
        <div className={["content-box", style.box].join(" ")}>
          <FullCycleDevelopment
            className={["section-img"].join(" ")}
            aria-label={"Full development cycle illustration"}
          />
          We're help&shy;ing our cli&shy;ents cre&shy;ate engag&shy;ing
          dig&shy;i&shy;tal expe&shy;ri&shy;ences and unlock new
          op&shy;por&shy;tu&shy;ni&shy;ties by pro&shy;vid&shy;ing{" "}
          <b>full-cycle soft&shy;ware devel&shy;op&shy;ment</b> ser&shy;vices.
        </div>
        <div className={["content-box", style.box].join(" ")}>
          <Scale
            className={["section-img"].join(" ")}
            aria-label={"From garage to an office building illustration"}
          />
          We work with our clients to increase their pro&shy;duc&shy;tiv&shy;ity
          and scale their oper&shy;a&shy;tions with ease by pro&shy;vid&shy;ing
          them with <b>expe&shy;ri&shy;enced experts</b> when they need them.
        </div>
        <div className={["content-box", style.box].join(" ")}>
          <Bpm
            className={["section-img"].join(" ")}
            aria-label={"BPM diagram illustration"}
          />
          We empower our clients to stream&shy;line their busi&shy;ness
          pro&shy;cesses thru{" "}
          <b>
            busi&shy;ness pro&shy;cess man&shy;age&shy;ment au&shy;toma&shy;tion
            con&shy;sult&shy;ing
          </b>
          .
        </div>
      </div>
      <div className={["link-more", style.more].join(" ")}>
        <Link to="/services/">Find out more</Link>
      </div>
    </div>
  </Layout>
)
